import { getSlots } from '@/api/networkFixer'
import { findSmsPromoRenewalSlot } from '@/helpers/channels/channelSlots'
import { useBillingStore } from '@/store/stores/billing'

/** Opens the project payment sidebar for the SMS slot that belongs to this promo. */
export async function openSmsPromoRenewalPayment(
    projectId: string,
    promo: { subscriptionId?: string | number | null; installId?: string | number | null }
): Promise<'opened' | 'missing-slot'> {
    const { data, error } = await getSlots({ projectId })
    const slot = error
        ? null
        : findSmsPromoRenewalSlot(
              Array.isArray(data) ? data : [],
              promo
          )
    if (!slot) return 'missing-slot'

    const billingStore = useBillingStore()
    await billingStore.fetchCurrentTariff(projectId)
    const current = billingStore.getCurrentTariff(projectId)
    if (current?.integrationId) {
        billingStore.selectedTariffId = current.integrationId
        billingStore.selectedSubscriptionPeriod = String(current.periodInMonths || '12')
    }
    const subscriptionId = Number(slot.subscriptionId)
    billingStore.setAddChannelContext({
        name: 'SMS',
        icon: null,
        kind: 'sms',
        subscriptionId: Number.isFinite(subscriptionId) ? subscriptionId : null,
        renewalMode: slot.renewalMode ?? null,
    })
    billingStore.setPaymentModalOpened(true, true)
    return 'opened'
}
